// Status vocab for Voucher/Refill/Reconciliation - passed as classMap/
// labelMap overrides into the shared components/common/StatusBadge (whose
// own defaults come from Stock's SUBMITTED/APPROVED/REJECTED/CANCELLED/
// ISSUED vocabulary and already cover everything here except PAID).
export const PETTY_CASH_VOUCHER_STATUS_CLASS = {
  SUBMITTED: "badge-linewarning",
  APPROVED: "badge-lineinfo",
  PAID: "badge-linesuccess",
  REJECTED: "badge-linedanger",
  CANCELLED: "badge-linedanger",
};
export const PETTY_CASH_VOUCHER_STATUS_LABEL = {
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  PAID: "Paid",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

export const PETTY_CASH_REFILL_STATUS_CLASS = {
  SUBMITTED: "badge-linewarning",
  APPROVED: "badge-lineinfo",
  ISSUED: "badge-linesuccess",
  REJECTED: "badge-linedanger",
  CANCELLED: "badge-linedanger",
};
// ISSUED reads as "Credited" since Batch141 (2026-09-08): approving a refill now posts the
// credit to the fund and takes the row straight to ISSUED, so there is no longer a separate
// issue step for anyone to be waiting on. APPROVED is only held by the legacy rows closed
// "for the record" by Batch142 - approved but never credited; "Credit to Fund" (the old
// issue step, re-enabled by Batch179) moves them to ISSUED.
export const PETTY_CASH_REFILL_STATUS_LABEL = {
  SUBMITTED: "Submitted",
  APPROVED: "Approved - not credited",
  ISSUED: "Credited to fund",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

export const PETTY_CASH_RECONCILIATION_STATUS_CLASS = {
  SUBMITTED: "badge-linewarning",
  APPROVED: "badge-linesuccess",
  REJECTED: "badge-linedanger",
};
export const PETTY_CASH_RECONCILIATION_STATUS_LABEL = {
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

// Receipt status (Batch137) is deliberately SEPARATE from voucher status, and the two
// are always shown together. A voucher that is PAID and still owes a receipt reads as
// "Paid" + "Receipt pending" - never as a bare "Pending", which would wrongly suggest
// the payment itself is outstanding.
export const PETTY_CASH_RECEIPT_STATUS_CLASS = {
  PENDING: "badge-linedanger",
  REQUIRED: "badge-linewarning",
  ATTACHED: "badge-linesuccess",
  NOT_REQUIRED: "badge-linedark",
};
export const PETTY_CASH_RECEIPT_STATUS_LABEL = {
  PENDING: "Receipt pending",
  REQUIRED: "Receipt required",
  ATTACHED: "Receipt attached",
  NOT_REQUIRED: "No receipt needed",
};

// Filter options for the voucher list / register report. NOT_REQUIRED is deliberately
// absent: nobody goes looking for "vouchers that never needed a receipt".
export const PETTY_CASH_RECEIPT_FILTERS = [
  { value: "", label: "Any receipt state" },
  { value: "PENDING", label: "Paid - receipt pending" },
  { value: "REQUIRED", label: "Receipt required (not paid yet)" },
  { value: "ATTACHED", label: "Receipt attached" },
];
